const comSwipeIcon = (() => {

  const trigger = document.querySelectorAll('.js-com-swipe-icon-trigger');
  const icon = document.querySelectorAll('.js-com-swipe-icon');
  if (trigger.length > 0 && icon.length > 0) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;


    for (let i = 0; i < trigger.length; i++) {

      if (sW > 750) {

        function isElementHorizontalScroll(element) {
          return element.scrollWidth > element.clientWidth;
        }

        trigger[i].addEventListener('scroll', function() {
          if (isElementHorizontalScroll(trigger[i])) {
            // 要素内で横スクロールが発生した場合の処理
            icon[i].style.display = 'none'
          }
        });

      } else {

        trigger[i].addEventListener('click', (event) => {
          icon[i].style.display = 'none'
        });

        trigger[i].addEventListener('touchstart', (event) => {
          icon[i].style.display = 'none'
        });

      }

    }


  }

})();
export default comSwipeIcon;